import { useState,useContext,useCallback } from "react";
import { formatDate, formatDateTime, getFriendlyDate } from "../Constants/constant";
import BasicButton from "../Usables/Buttons";
import InputField from "../Usables/InputField";
import Dropdown from "../Usables/Dropdown";
import Pagination from '../Usables/Pagination';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AppContext } from '../ContextApi/ContextApi';
import { basePath } from '../Constants/constant';
import CloseModal from "../Usables/CloseModal";
import { toast } from "react-toastify";

const TodoList = ({handleClose,  todoList, getTodoList, handleLimit, handlePrev, handleNext, 
    pagination, allUsers,setUsersOption,handleChangeFilter, loadingFilter, handleClear, 
    setFilterData, filterData, handleFilter, usersOption, handleExport }) => {
    const {apiHeaderJSON} = useContext(AppContext);
    let [showReslove , setShowReslove] = useState(false);
    let [loading , setLoading] = useState(false);
    let [formData , setFormData] = useState({});
    
    const taskStatusList = [
        { value: '0', label:"Pending"},
        { value: '1', label:"Close"},
    ]
    
    const handlebuttonClick = (val) =>{
        setShowReslove(val);
        setFormData({ ...formData, task_id:val?.task_id});
    }

    const handleReslove = (e) => {
        e.preventDefault();
        // console.log(formData);
       
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to Close For Today this task!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Close For Today!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
        }).then(async (result) => {

            if (!result.isConfirmed) return;

            setLoading(true);
            // console.log(`formData`,formData);
            const data = {
                task_id: formData?.task_id,
                remarks : formData?.task_remarks
            };

            const options = {
                headers: apiHeaderJSON
            };
            
            try {
            const response = await axios.post(`${basePath}/Tasks/ResloveTask`, data, options);
                // console.log(`response ===>`, response);
            if (response.status === 200 && response.data?.success !== false) {
                setLoading(false);
                setFormData({
                task_id: "",
                task_remarks: "",
                });
                getTodoList();
                setShowReslove(false);
                toast.success(response.data?.message || "Task Resloved Successfully");
            } else {
                setLoading(false);
                toast.error(response.data?.message || "Unable to reslove task");
            }
            } catch (error) {
                setLoading(false);
                if (error.response) {
                    console.error("Task Resloved Response error:", error.response.status, error.response.data);
                    toast.error(error.response.data?.message || "Failed to Reslove Task");
                } else {
                    // Network or other error
                    console.error("Request error:", error.message);
                    toast.error("Network or unexpected error occurred.");
                }
            }
        });
    };

    const handleCloseMark = () => {
        setShowReslove(false);
        setFormData({});
    };

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{
            // console.log("val?.activated === e.target.value",idx + 1,"=>",val?.activated, num,val?.activated === num)
            if(val?.activated === num) return val;
        });
        setFilterData({ ...filterData, isActive: checked }); 
        // console.log("all",all);
        setUsersOption(all);
    },[allUsers, filterData]);

    return (
        <div className="w-full h-screen fixed inset-0 z-20 flex items-center justify-center blurBack">
            <div  onClick={(e) => e.stopPropagation()} className=' relative lightBabyGreen mx-5 p-5 rounded-lg w-full h-[95dvh]'>
                <div className=" flex justify-between items-center mb-2">
                    <h2 className="text-xl font-semibold text-gray-800">
                        All Tasks
                    </h2>
                    <CloseModal disabled={loading} onClick={handleClose} />
                </div>
                {/*Filters */}
                <div className=' grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 rounded-xl'>
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    disabled={loading === '1'}
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                    disabled={loading === '1'}
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ?
                        null :
                        <Dropdown id="recruiterId" name="recruiterId" label="Recruiter:"
                        onChange={handleChangeFilter}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiterId}
                        options={usersOption}
                        search={true} // to enable search input
                        checkBox={true} // to enable checkbox
                        checkValue={filterData?.isActive} // to make checkbox check and uncheck
                        onCheck={handleCheck} // to make changes in list of options onChange  
                    />
                    }
                    <Dropdown id="taskStatus" name="taskStatus"
                        onChange={handleChangeFilter}
                        onCancel={handleChangeFilter}
                        label="Task Status:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`All`}
                        value={filterData?.taskStatus}
                        options={taskStatusList}
                    />

                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={ loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.recruiterId && !filterData?.taskStatus)}
                            //  loading={loadingFilter === "1"} 
                            loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={ loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.recruiterId && !filterData?.taskStatus)}
                            // loading={loadingFilter === "2"}
                             loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                            <BasicButton onClick={() => handleExport()} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                            disabled={loadingFilter } 
                           loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                        </div>
                    </div>
                </div>
                <div className=' bg-white p-2 rounded-lg grayBlurShadow mt-4'>
                    <div className='mt-4 h-[57vh] overflow-auto'>
                        <div className="flex flex-col p-1">
                            <div className=" ">
                                {todoList?.map((val, idx) => (
                                <div key={idx} className=" grayBlurShadow p-4 border-b rounded-md hover:bg-gray-50 transition duration-500 ease-in-out mb-3">
                                    {/* Task Title & Priority */}
                                    <div className="flex justify-between items-center mb-1">
                                        <h5 className={`font-semibold ${val?.task_date && getFriendlyDate(val.task_date) === "Today" ? "text-green-700 bg-green-200 rounded-full px-2" : getFriendlyDate(val.task_date) === "Tomorrow" ? "text-blue-800 bg-blue-200 rounded-full px-2" :
                                        getFriendlyDate(val.task_date) === "Yesterday" ? "text-amber-500 bg-amber-200 rounded-full px-2" : "text-black" }  hover:underline cursor-pointer`}>{val?.task_date ? getFriendlyDate(val.task_date) : "N/A"}</h5>
                                        <span className={`font-semibold px-2 py-1 rounded-full ${val?.priority_classes}`}>
                                        {val?.priority_label}
                                        </span>
                                    </div>
                                    {/* Additional Task Details */}
                                    <div className="grid grid-cols-4 gap-x-4 gap-y-1 text-xs text-gray-500 text-left m-3 items-center">
                                        <p>
                                            <span className="font-medium text-gray-700">Assigned at:</span>{" "}
                                            {val?.created_date ? formatDateTime(val.created_date) : "N/A"}
                                        </p>
                                        <p>
                                            <span className="font-medium text-gray-700">Status:</span>
                                            <span
                                            className={`${
                                                val?.task_status === 0
                                                ? " batch-warning"
                                                : val?.task_status === 1
                                                ? "batch-success"
                                                : "batch-info"
                                            } font-medium px-3 py-1 rounded-full`}
                                            >
                                            {val?.task_status === 1 ? "Close" : "Pending"}
                                            </span>
                                        </p>
                                        <p>
                                            <span className="font-medium text-gray-700">Resolved at:</span>
                                            {val?.task_reslove_date ? formatDateTime(val.task_reslove_date) : "N/A"}
                                        </p>
                                        <div className="flex items-center gap-2 text-sm">
                                        <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 font-medium">
                                            {val?.assigned_by?.name || "N/A"}
                                        </span>
                                        <span className="text-gray-500">→</span>
                                        <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 font-medium">
                                            {val?.assigned_to?.name || "N/A"}
                                        </span>
                                    </div>
                                    </div>
                                    <hr />
                                    {/* Description */}
                                    <p className="text-gray-600 text-sm m-2 text-left max-h-[100px] overflow-auto">
                                    <span className="text-gray-900 text-md font-semibold">Description:</span> {val?.task_description  || "No description provided."}
                                    </p>
                                    {val?.recruiter_remark  && 
                                    <p className="text-gray-600 text-sm m-2 text-left mt-3">
                                    <span className="text-gray-900 text-md font-semibold">User Remarks:</span> {val?.recruiter_remark || ""}
                                    </p>
                                    }
                                    {val?.show_action_button  &&
                                    <div className="flex justify-end mt-1">
                                        <BasicButton  onClick ={() => handlebuttonClick(val)}
                                        buttonName='Close For Today' className='darkPurple text-nowrap' shadow={true}  
                                        padding="py-1 px-3" rounded="lg" textAlign="center" fontWeight="normal" onHover="hoverGreen" />
                                    </div>
                                    }
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                    limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                    disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                    />
                </div>
            </div>
            {/*Reslove task pop up */ }
            {showReslove && 
             <div onClick={(e) => e.stopPropagation()} className="w-full h-screen fixed inset-0 z-20 flex items-center justify-center bg-black/30 backdrop-blur-sm">
                    <div  className="bg-white overflow-auto max-h-[90vh] mx-6 mb-5 p-6 rounded-xl shadow-lg w-full max-w-3xl">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-semibold text-gray-800">
                            Close
                        </h2>
                        <button
                            onClick={() => handleCloseMark()}
                            className="text-gray-500 hover:text-red-500 text-xl"
                        >
                            ✕
                        </button>
                        </div>
                        <div className="space-y-4">
                            {/* Title */}
                            <div>
                                <h3 className="text-left"><span className=" text-lg font-bold text-gray-900">Task Tilte: </span>{showReslove?.task_title}</h3>
                            </div>
                            <form onSubmit={handleReslove} className="flex flex-col gap-4 w-full">
                                <div>
                                    <InputField
                                        id="task_remarks"
                                        name="task_remarks"
                                        type="text"
                                        label="Remarks:"
                                        placeholder="Remarks"
                                        value={formData?.task_remarks}
                                        onChange={(e) => setFormData({ ...formData, task_remarks: e.target.value,})}
                                        // error={errors?.task_title}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="flex justify-end mt-1">
                                    <BasicButton type= 'submit'
                                    buttonName='Close For Today' className='darkPurple text-nowrap' shadow={true} disabled={loading} 
                                    padding="py-2 px-5" rounded="lg" textAlign="center" fontWeight="normal" onHover="hoverGreen" />
                                </div>
                            </form>
                        </div>
                    </div>
             </div>
            
            }
        </div>
    );
}

export default TodoList;
